import styled from 'styled-components'
import { TABLET_BREAKPOINT } from 'styles/breakpoints'

export const SearchPageListHeaderWrapper = styled.div<{
  hideBottomBorder?: boolean
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 10px;
  max-width: 100%;

  svg {
    color: ${({ theme }) => theme.secondary};
    cursor: pointer;
  }

  .green {
    color: ${({ theme }) => theme.highlight};
  }
`
